import React from "react";

interface UmapControlsProps {
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

const UmapControls: React.FC<UmapControlsProps> = ({
  onSelectAll,
  onDeselectAll,
}) => {
  return (
    <div className="flex space-x-2">
      <button
        onClick={onSelectAll}
        className="px-4 py-2 text-sm font-medium text-white bg-blue-800 rounded-md hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        Select All
      </button>
      <button
        onClick={onDeselectAll}
        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
      >
        Deselect All
      </button>
    </div>
  );
};

export default UmapControls;
